module.exports = __webpack_public_path__ + "img/layout-6_1.e7e9e926.png";